import { useState, createContext, useContext, useCallback } from 'react';

import VenueDetailModal from './index';

const POIVenueDetailContext = createContext();

const POIVenueDetailContextProvider = ({ children }) => {
  const [activeGID, setActiveGID] = useState(null);
  const [activeAddressId, setActiveAddressId] = useState(null);
  const [isCreating, setIsCreating] = useState(false);

  const handleOpenModal = useCallback((gid, { addressId } = {}) => {
    setActiveGID(gid);
    setActiveAddressId(addressId);
  }, []);

  const onClose = useCallback(() => {
    setActiveGID(null);
    setActiveAddressId(null);
    setIsCreating(false);
  }, []);

  const openCreationModal = useCallback(({ addressId } = {}) => {
    setIsCreating(true);
    setActiveAddressId(addressId);
  }, []);

  const value = {
    openModal: handleOpenModal,
    openCreationModal,
    closeModal: onClose,
    activeGID,
    activeAddressId,
  };

  return (
    <>
      <POIVenueDetailContext.Provider value={value}>
        <>{children}</>
        {activeGID || isCreating ? (
          <VenueDetailModal
            onClose={onClose}
            gid={activeGID}
            addressId={activeAddressId}
            isCreating={isCreating}
          />
        ) : null}
      </POIVenueDetailContext.Provider>
    </>
  );
};

const usePOIVenueDetail = () => {
  return useContext(POIVenueDetailContext);
};

export { POIVenueDetailContextProvider, usePOIVenueDetail };
